// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"da8cbd37","54":"8663bda0","73":"604a04c2","399":"6158c9e0","646":"2db2b4e4","674":"ad8ead05"}[chunkId] + ".chunk.js";
};